export default __webpack_public_path__ + "static/media/gb-wls.0a94356c.svg";